<script>
import { authComputed } from '@state/helpers'
import getSecret from '@utils/get-secret'
let _ = require('lodash')
// import VuePerfectScrollbar from 'vue-perfect-scrollbar'

export default {
  // components: { VuePerfectScrollbar },
  props: {
    user: {
      type: Object,
      required: true,
      default: () => ({ is_superuser: false }),
    },
  },
  data() {
    return {
      redColaborativaDomain: '',
      actualDomain: '',
    }
  },

  computed: {
    ...authComputed,
    getCompanyInfo: function() {
      return this.$store.state.appAuth.companyInfo || null
    },
    isRed() {
      const host = window.location.host
      const parts = host.split(/[:.]+/)
      this.actualDomain = parts[0]
      this.redColaborativaDomain = getSecret('RED_COLABORATIVA')
      return this.actualDomain == this.redColaborativaDomain
    },
    langSelected: {
      get() {
        return this.$store.state.language.language
      },
      set(val) {
        this.$store.commit('language/SET_LANGUAGE', val)
      },
    },
    langFlagSelected: function() {
      return this.$store.state.language.languages.find(
        (x) => this.langSelected === x.value
      ).flag
    },
    // getMenu: function () {
    //   if (user.is_superuser){
    //     return null
    //   }
    //   return this.$store.state.auth.currentSession ? this.$store.state.auth.currentSession.user.app_sections_tree : []
    // }
  },
  methods: {
    toggleMenu() {
      this.$parent.toggleMenu()
    },
    toggleRightSidebar() {
      this.$parent.toggleRightSidebar()
    },
  },
}
</script>

<template>
  <!-- Topbar Start -->
  <div class="navbar-custom">
    <ul class="list-unstyled topnav-menu float-right mb-0">
      <!-- <li class="d-none d-sm-block">
        <form class="app-search">
          <div class="app-search-box">
            <div class="input-group">
              <input
                type="text"
                class="form-control"
                placeholder="Search..."
              />
              <div class="input-group-append">
                <button
                  class="btn"
                  type="submit"
                >
                  <i class="fad fa-search"></i>
                </button>
              </div>
            </div>
          </div>
        </form>
      </li> -->
      <!-- Traduction options -->
      <!-- <b-nav-item-dropdown
          right
          class="notification-list"
          menu-class="language-dropdown"
        >
          <template slot="button-content">
            <div class="nav-lang mr-0 waves-effect waves-light">
              <img
                :src="require('@assets/images/flags/'+(langFlagSelected || 'ss')+'.svg')"
                alt="lang-image"
                width="20"
              />
              <span class="pro-user-name ml-1">
                <i class="fad fa-chevron-down"></i>
              </span>
            </div>
          </template>
          <b-dropdown-item v-for="(lang, i) in $store.state.language.languages" :key="`Lang${i}`" @click="langSelected = lang.value">
            <img
              :src="require('@assets/images/flags/'+lang.flag+'.svg')"
              width="20"
              class="mr-2"
            />
            <span>{{ lang.name }}</span>
          </b-dropdown-item>
        </b-nav-item-dropdown> -->

      <!-- User dropdown -->
      <b-nav-item-dropdown
        v-if="loggedIn"
        right
        class="notification-list user-drop"
        menu-class="profile-dropdown"
      >
        <template slot="button-content">
          <div class="nav-user mr-0 waves-effect waves-light">
            <img
              :src="
                currentSession.user.user_info &&
                currentSession.user.user_info.photo
                  ? currentSession.user.user_info.photo
                  : require('@assets/images/users/avatar-clear.png')
              "
              alt="user-image"
              class="rounded-circle"
            />
            <i class="fad fa-chevron-down"></i>
          </div>
        </template>
        <b-dropdown-item disabled>
          <div class="row">
            <img
              :src="
                currentSession.user.user_info &&
                currentSession.user.user_info.photo
                  ? currentSession.user.user_info.photo
                  : require('@assets/images/users/avatar-clear.png')
              "
              alt="user-image"
              class="rounded-circle"
              fluid
            />
            <div class="user-label">
              <h5 class="p-0 m-0">
                {{
                  currentSession.user.first_name
                    ? _.capitalize(currentSession.user.first_name)
                    : ''
                }}
                {{
                  currentSession.user.last_name
                    ? _.capitalize(currentSession.user.last_name)
                    : ''
                }}
                <p class="text-muted mb-0"
                  ><small>{{ currentSession.user.email }}</small></p
                >
              </h5>
            </div>
          </div>
        </b-dropdown-item>
        <b-dropdown-divider></b-dropdown-divider>
        <b-dropdown-item href="/management/security/">
          <i class="fad fa-key mr-1"></i>
          <span>{{ $t('pages.Security') }}</span>
        </b-dropdown-item>
        <b-dropdown-item href="/logout">
          <i class="fad fa-right-from-bracket mr-1 text-primary"></i>
          <span>{{ $t('Logout') }}</span>
        </b-dropdown-item>
      </b-nav-item-dropdown>
      <!-- <li class="dropdown notification-list">
        <button
          class="btn btn-link nav-link right-bar-toggle waves-effect waves-light"
          @click="toggleRightSidebar"
        >
          <i class="fad fa-sliders noti-icon"></i>
        </button>
      </li> -->
    </ul>

    <!-- LOGO -->
    <div class="logo-box">
      <a href="/" class="logo text-center">
        <span class="logo-lg">
          <img
            style="vertical-align: middle;border-style: none;"
            v-if="getCompanyInfo && getCompanyInfo.light_logo && !isRed"
            :src="require('@assets/images/logos/logo-dark-medium.png')"
            alt=""
            height="55"
            class="p-1"
          />
          <img
            style="vertical-align: middle;border-style: none;"
            v-else="getCompanyInfo && isRed"
            :src="require('@assets/images/logos/logo-red-short.png')"
            alt=""
            height="55"
            class="p-1"
          />
          <!-- <span class="logo-lg-text-light">Xeria</span> -->
        </span>
        <span class="logo-sm d-md-none">
          <!-- <span class="logo-sm-text-dark">X</span> -->
          <img
            v-if="getCompanyInfo"
            :src="
              getCompanyInfo.short_light_logo ||
                getCompanyInfo.short_dark_logo ||
                require('@assets/images/logos/logo-dark-short.png')
            "
            alt=""
            class="p-1"
            height="50"
          />
        </span>
      </a>
    </div>

    <ul
      class="list-unstyled topnav-menu topnav-menu-left m-0"
      :class="user.is_superuser ? 'd-block' : 'd-block d-sm-block'"
    >
      <li>
        <button
          class="button-menu-mobile waves-effect waves-light"
          @click="toggleMenu"
        >
          <i class="fad fa-bars"></i>
        </button>
      </li>
    </ul>

    <!-- <b-nav-item v-for="(entry, index) in getMenu" 
        :id="`first-lv-${index}-${entry.id}`" 
        :key="index" 
        :class="{ active: entry.active }"
        :to=" { path: entry.path }"
        v-show="'path' in entry && entry.path"
        class="list-unstyled topnav-menu float-left m-0">
        <FontAwesomeIcon fixed-width :icon="entry.icon_name || 'fa-arrow-right'" /><br>
        {{ entry.name }}
      </b-nav-item>
      <div v-for="(entry, index) in getMenu" :key="index+1000" >
        <b-nav-item v-for="(childsecondlv, chsecondlvidx) in entry.children" 
          :id="`second-lv-${chsecondlvidx}-${entry.id}-${childsecondlv.id}`" 
          :key="chsecondlvidx" 
          :class="{ active: childsecondlv.active }" 
          :to="{ path: childsecondlv.path }"
          class="list-unstyled topnav-menu float-left m-0"
          v-show="'path' in childsecondlv && childsecondlv.path"
          >
          <FontAwesomeIcon fixed-width :icon="childsecondlv.icon_name || 'fa-arrow-right'" /><br>
          {{ childsecondlv.name }}
        </b-nav-item>
      </div> -->
  </div>
  <!-- end Topbar -->
</template>

<style lang="scss">
.noti-scroll {
  height: 220px;
}
.ps > .ps__scrollbar-y-rail {
  width: 8px !important;
  background-color: transparent !important;
}
.ps > .ps__scrollbar-y-rail > .ps__scrollbar-y,
.ps.ps--in-scrolling.ps--y > .ps__scrollbar-y-rail > .ps__scrollbar-y,
.ps > .ps__scrollbar-y-rail:active > .ps__scrollbar-y,
.ps > .ps__scrollbar-y-rail:hover > .ps__scrollbar-y {
  width: 6px !important;
}
.button-menu-mobile {
  outline: none !important;
}
.user-drop {
  ul {
    min-width: 260px;
  }
  img {
    flex: auto;
    max-width: 45px;
    max-height: 45px;
    margin-right: 8px;
  }
  .user-label {
    flex: 0 0 70%;
    max-width: 70%;
  }
}
</style>
